<template>
	<div class="home-container">
		<div class="linear-bg"></div>
		<header class="home-header">
			<div class="header-left">
				<div class="logo-box">
					<img src="/img/detail/header-logo.png" alt="Logo" />
				</div>
				<div class="tab-list">
					<button class="tab-btn" :class="{ active: activeTab === 'recommend' }" @click="activeTab = 'recommend'">{{$t('index.recmonmand')}}</button>
					<button class="tab-btn" :class="{ active: activeTab === 'video' }" @click="switchToVideo">{{$t('video.video')}}</button>
				</div>
			</div>
			<div class="header-right">
				<button class="lang-btn" @click="showLangMenu = !showLangMenu">
					<span>{{ currentLangName }}</span>
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<path d="m6 9 6 6 6-6"></path>
					</svg>
				</button>
				<div class="lang-menu" v-if="showLangMenu">
					<div
						class="lang-menu-item"
						:class="{ active: $i18n.locale === item.code }"
						v-for="item in langList"
						:key="item.code"
						@click="changeLang(item.code)"
					>{{ item.name }}</div>
				</div>
			</div>
		</header>
		<div class="home-scroll" v-if="activeTab === 'recommend'">
			<div class="banner">
				<van-image class="banner_img" fit="contain" :src="banners[0] ? banners[0].url : ''" v-if="banners.length > 0">
					<template v-slot:loading>
						<van-loading type="circular" />
					</template>
				</van-image>
			</div>
			<div class="notice-bar">
				<van-notice-bar class="notice-swipe" left-icon="bullhorn-o" background="#1a1a1a" color="#f487e0"
					:text="this.notice" />
				<div class="linear-gradient"></div>
			</div>
			<div class="hot-game">
				<div class="section-header">
					<div class="section-title-left">
						<van-icon name="fire-o" class="title-icon" />
						<span class="section-title">{{$t('index.task')}}</span>
					</div>
					<span class="section-more" @click="gotoMenu('/Game')">{{$t('index.more')}}</span>
				</div>
				<div class="entry-list">
					<div class="entry-item" v-for="(v,key) in gameitem" :key="key" @click="toLottery(v.key,v.id)">
						<div class="entry-icon-box">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="entry-svg">
								<path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
							</svg>
						</div>
						<div class="entry-content">
							<span class="entry-name">{{v.name_zh_cn}}</span>
						</div>
						<van-icon name="arrow" class="entry-arrow" />
					</div>
				</div>
			</div>
			<van-pull-refresh pulling-text="刷新成功" 
			loosing-text="页面刷新" 
			loading-text="刷新成功" 
			success-text="刷新成功" v-model="isLoading" @refresh="onRefresh">
				<div class="hot-recommend">
					<div class="section-header">
						<div class="section-title-left">
							<van-icon name="fire-o" class="title-icon" />
							<span class="section-title">{{$t('index.hot')}}</span>
						</div>
						<span class="section-more" @click="gotoMenu('/Video')">{{$t('index.more')}}</span>
					</div>
					<div class="movie_list_0">
						<swiper class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v,key) in movielist_0" :key="key">
								<van-image class="movie_cover" @click="toPlayVideo(v.id)" round :src="v.cover">
									<template v-slot:loading>
										<van-loading type="circular" />
									</template>
								</van-image>
								<img class="hot" v-if="key === 0" src="/img/home/no1.png">
								<img class="hot" v-if="key === 1" src="/img/home/no2.png">
								<img class="hot" v-if="key === 2" src="/img/home/no3.png">
								<div class="movie-list-item-bottom">
									<div class="movie-time-div">
										<span>{{v.title}}</span>
										<div class="van-count-down">{{v.time}}</div>
									</div>
								</div>
							</swiper-slide>
						</swiper>
					</div>
					<div class="section-header">
						<div class="section-title-left">
							<van-icon name="fire-o" class="title-icon" />
							<span class="section-title">{{$t('index.recmonmand')}}</span>
						</div>
						<span class="section-more" @click="gotoMenu('/Video')">{{$t('index.more')}}</span>
					</div>
					<div class="movie_list_1">
						<div class="movie-list-item" v-for="(v,key) in movielist_1" :key="key"
							@click="toPlayVideo(v.id)">
							<van-image class="cover_img" round :src="v.cover">
								<template v-slot:loading>
									<van-loading type="circular" />
								</template>
							</van-image>
							<div class="movie-list-item-bottom">
								<div class="movie-time-div">
									<span>{{v.title}}</span>
									<span>{{$t('video.play')}}:{{v.count}}</span>
								</div>
							</div>
						</div>
						<div class="hot-recommend-more" @click="gotoMenu('/Video')">{{$t('index.more')}}</div>
					</div>
				</div>
			</van-pull-refresh>
		</div>
		<div class="video-tab" v-if="activeTab === 'video'">
			<van-tabs v-model="activeVideoClass" animated swipeable @change="onVideoClassChange">
				<van-tab v-for="(v,key) in videolitem" :key="key" :title="v.zh_cn" :name="v.key"></van-tab>
			</van-tabs>
			<div class="video-list-wrap">
				<div class="video-grid">
					<div class="video-grid-item" v-for="(v,key) in videolist" :key="key" @click="toPlayVideo(v.id)">
						<van-image class="video-cover" round :src="v.vod_pic">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
						<div class="video-info">
							<span class="video-title">{{v.vod_name}}</span>
							<span class="video-plays">{{$t('video.play')}}:{{v.count}}</span>
						</div>
					</div>
				</div>
				<div class="video-load-more" v-if="!videoFinished" @click="loadMoreVideo">{{$t('index.more')}}</div>
				<div class="video-no-more" v-else>{{$t('video.no_more')}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				notice: this.$t("index.loading"),
				banners: [{}],
				basicData: [],
				gameitem: [{}, {}, {}, {}],
				movielist_0: [{}, {}, {}, {}],
				movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
				isLoading: false,
				activeTab: 'recommend',
				showLangMenu: false,
				activeVideoClass: 0,
				videolitem: [],
				videolist: [],
				videoPage: 0,
				videoCount: 0,
				videoFinished: false,
				langList: [
					{ code: 'zh_cn', name: '简体中文' },
					{ code: 'en_us', name: 'English' }
				],
				movielistSwiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					slidesPerGroup: 1,
				},
				bannerSwiperOption: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					speed: 800,
					autoplay: true,
					coverflowEffect: {
						rotate: 50,
						stretch: 10,
						depth: 100,
						modifier: 1,
						slideShadows: true
					}
				}
			};
		},
		computed: {
			currentLangName() {
				let lang = this.langList.find(l => l.code === this.$i18n.locale);
				return lang ? lang.name : '中文';
			}
		},
		methods: {
			handleOutsideClick(e) {
				if (this.showLangMenu && !this.$el.querySelector('.header-right').contains(e.target)) {
					this.showLangMenu = false;
				}
			},
			changeLang(code) {
				this.$i18n.locale = code;
				localStorage.setItem('lang', code);
				this.showLangMenu = false;
			},
			switchToVideo() {
				this.activeTab = 'video';
				if (this.videolitem.length === 0) {
					this.getVideoClass();
				}
			},
			getVideoClass() {
				this.$http({
					method: 'get',
					url: 'video_class'
				}).then(res => {
					this.videolitem = res.data;
					this.onVideoClassChange();
				})
			},
			onVideoClassChange() {
				this.videolist = [];
				this.videoPage = 0;
				this.videoCount = 0;
				this.videoFinished = false;
				this.getVideoList();
			},
			getVideoList() {
				this.$http({
					method: 'get',
					data: { id: this.activeVideoClass, page: this.videoPage },
					url: 'video_list'
				}).then(res => {
					this.videolist = this.videolist.concat(res.data.data);
					this.videoCount = res.data.count;
					this.videoPage++;
					if (this.videolist.length >= this.videoCount) {
						this.videoFinished = true;
					}
				})
			},
			loadMoreVideo() {
				this.getVideoList();
			},
			gotoMenu(router) {
				this.$router.replace(router)
			},
			toLottery(key, id) {
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					this.$router.push({
						path: '/Lottery?key=' + key + "&id=" + id
					})
				}

			},
			toPlayVideo(id) {
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					this.$router.push({
						path: '/PlayVideo?id=' + id
					})
				}
			},
			onRefresh() {
				setTimeout(() => {
					this.getBasicConfig();
					this.isLoading = false;
					this.$toast(this.$t("index.refresh_success"));
				}, 500);
			},
			getBasicConfig() {
				this.$http({
					method: 'get',
					url: 'sys_config'
				}).then(res => {
					this.basicData = res.data;
					console.info(res)
					this.getNotice(this.basicData); //获取公告
					this.getBanner(this.basicData); //获取banner
					this.getGameItem(); //获取首页游戏列表
					this.getMovieList_0(this.basicData); //获取首页视频0
					this.getMovieList_1(this.basicData); //获取首页视频1
				})

			},
			getNotice(data) {
				this.notice = data.notice;
			},
			getGameItem() {
				this.$http({
					method: 'get',
					url: 'lottery_hot'
				}).then(res => {
					this.gameitem = res.data
				})
			},
			getMovieList_0(data) {
				this.movielist_0 = data.movielist_0
			},
			getMovieList_1(data) {
				this.movielist_1 = data.movielist_1
			},
			getBanner(data) {
				this.banners = data.banners;
			}
		},
		mounted() {
			document.addEventListener('click', this.handleOutsideClick);
		},
		beforeDestroy() {
			document.removeEventListener('click', this.handleOutsideClick);
		},
		created() {
			this.getBasicConfig();
		}
	}
</script>

<style lang='less' scoped>
	@notice-bar-size: 30px;
	@movie-list-item-bottom-size: 25px;

	.linear-bg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 200px;
		background: linear-gradient(270deg, #1a1a2e, #16213e);
		z-index: 1;
	}

	.home-header {
		position: relative;
		z-index: 100;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding: 24px 32px 16px;
	}

	.header-left {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.logo-box {
		width: 72px;
		height: 72px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border-radius: 16px;
		background: linear-gradient(135deg, rgba(59, 158, 255, 0.3), rgba(41, 128, 185, 0.2));
		box-shadow: 0 0 0 2px rgba(59, 158, 255, 0.4);
	}

	.logo-box img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.tab-list {
		display: flex;
		gap: 16px;
	}

	.tab-btn {
		height: 74px;
		width: 140px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 9999px;
		font-size: 26px;
		border: 2px solid #334155;
		background: transparent;
		color: rgba(255, 255, 255, 0.9);
		transition: all 0.3s;
	}

	.tab-btn.active {
		background: linear-gradient(to bottom, #3b9eff, #2980b9);
		border-color: transparent;
		font-weight: 600;
		color: #fff;
		box-shadow: 0 4px 16px rgba(52, 152, 219, 0.45);
	}

	.header-right {
		position: relative;
		margin-top: 4px;
	}

	.lang-btn {
		display: flex;
		min-width: 176px;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		border-radius: 9999px;
		background: #2a2548;
		padding: 12px 24px;
		font-size: 28px;
		color: rgba(255, 255, 255, 0.95);
		box-shadow: 0 0 20px rgba(155, 89, 182, 0.35);
		border: 2px solid rgba(155, 89, 182, 0.5);
	}

	.lang-btn:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.lang-btn svg {
		width: 28px;
		height: 28px;
		opacity: 0.8;
	}

	.lang-menu {
		position: absolute;
		top: 100%;
		right: 0;
		margin-top: 12px;
		background: #1a1a2e;
		border-radius: 16px;
		overflow: hidden;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
		min-width: 220px;
		z-index: 200;
	}

	.lang-menu-item {
		padding: 20px 24px;
		font-size: 26px;
		color: rgba(255, 255, 255, 0.9);
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}

	.lang-menu-item:last-child {
		border-bottom: none;
	}

	.lang-menu-item.active {
		color: #f487e0;
		font-weight: 600;
	}

	.lang-menu-item:active {
		background: rgba(255, 255, 255, 0.1);
	}

	.video-tab {
		padding: 0 30px;
	}

	.video-tab ::v-deep .van-tabs__nav {
		background-color: #0a0a0a;
	}

	.video-tab ::v-deep .van-tab {
		color: #888;
	}

	.video-tab ::v-deep .van-tab--active {
		color: #f487e0;
	}

	.video-tab ::v-deep .van-tabs__line {
		background-color: #f487e0;
	}

	.video-list-wrap {
		padding: 20px 0;
	}

	.video-grid {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.video-grid-item {
		width: 48%;
		margin-bottom: 30px;
	}

	.video-cover {
		border-radius: 16px;
		width: 100%;
		height: 290px;
	}

	.video-info {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 8px 0;
	}

	.video-title {
		font-size: 26px;
		color: #fff;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		max-width: 60%;
	}

	.video-plays {
		font-size: 22px;
		color: #888;
	}

	.video-load-more {
		text-align: center;
		padding: 20px;
		color: #f487e0;
		font-size: 28px;
	}

	.video-no-more {
		text-align: center;
		padding: 20px;
		color: #555;
		font-size: 26px;
	}

	.home-container {
		position: absolute !important;
		top: 0;
		left: 0;
		right: 0;
		background-color: #0a0a0a;
	}

	.linear-gradient {
		width: 100%;
		height: 2px;
		background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));
	}

	::v-deep .van-notice-bar__left-icon,
	.van-notice-bar__right-icon {
		min-width: 40px;
	}

	.notice-swipe {
		width: calc(100% - 50px);
		height: 85px;
		font-size: @notice-bar-size;
	}

	::v-deep .van-icon-bullhorn-o::before {
		transform: scale(2.5);
	}

	.banner {
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		margin-top: 20px;
	}

	.banner_swiper {
		height: 100%;
		width: 100%;

		.swiper-slide {
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 620px;
			height: 300px;
			text-align: center;
			font-weight: bold;
			font-size: 20px;
			background-color: #1a1a1a;
			background-position: center;
			background-size: cover;
			color: #ffffff;
		}
	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-left {
		background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-right {
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	.banner_img {
		border-radius: 10px;
		width: 100%;
		height: auto;
		min-height: 200px;
	}

	.hot-game {
		width: 100%;
		padding: 0 30px;
		margin-top: 40px;
		box-sizing: border-box;
	}

	.section-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 24px;
	}

	.section-title-left {
		display: flex;
		align-items: center;
	}

	.title-icon {
		font-size: 32px;
		color: #f487e0;
		margin-right: 12px;
	}

	.section-title {
		font-size: 30px;
		font-weight: 600;
		color: #fff;
	}

	.section-more {
		font-size: 24px;
		color: #888;
	}

	.entry-list {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.entry-item {
		display: flex;
		width: 100%;
		align-items: center;
		border-radius: 24px;
		background: #1a1a2e;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
		padding: 28px 32px;
		transition: transform 0.2s;
	}

	.entry-item:active {
		transform: scale(0.99);
	}

	.entry-icon-box {
		display: flex;
		width: 80px;
		height: 80px;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		border-radius: 20px;
		margin-right: 24px;
	}

	.entry-item:nth-child(1) .entry-icon-box {
		background: rgba(244, 135, 224, 0.12);
	}

	.entry-item:nth-child(2) .entry-icon-box {
		background: rgba(152, 143, 186, 0.12);
	}

	.entry-item:nth-child(3) .entry-icon-box {
		background: rgba(126, 86, 120, 0.12);
	}

	.entry-item:nth-child(4) .entry-icon-box {
		background: rgba(230, 195, 161, 0.18);
	}

	.entry-svg {
		width: 40px;
		height: 40px;
	}

	.entry-item:nth-child(1) .entry-svg {
		color: #f487e0;
	}

	.entry-item:nth-child(2) .entry-svg {
		color: #988fba;
	}

	.entry-item:nth-child(3) .entry-svg {
		color: #7e5678;
	}

	.entry-item:nth-child(4) .entry-svg {
		color: #c9a06a;
	}

	.entry-content {
		flex: 1;
		min-width: 0;
	}

	.entry-name {
		font-size: 30px;
		font-weight: 500;
		color: #fff;
	}

	.entry-arrow {
		font-size: 32px;
		color: #555;
		flex-shrink: 0;
	}

	.hot-recommend {
		width: 100%;
		flex: 1;
		background-color: #0a0a0a;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.movie_swiper {
		.swiper-slide {
			width: 80%;
		}
	}

	.movie_list_0 {
		width: calc(100% - 50px);
		margin: 0 auto;
	}

	.movie_cover {
		border-radius: 10px;
		width: 550px;
		height: 330px
	}

	.movie_list_0 .movie-list-item-bottom {
		position: relative;
		width: 550px;
		bottom: 43px;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_0 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
		font-size: 28px;
		color: #fff;
	}

	.movie_list_0 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
	}

	.movie_list_0 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 80px;
	}

	.movie_list_0 span {
		font-size: 30px;
	}

	.movie_list_1 {
		display: flex;
		width: 100%;
		margin: 0 auto;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.movie_list_1 .movie-list-item .cover_img {
		border-radius: 10px;
		width: 100%;
		height: 290px;
	}

	.home-scroll {
		padding-bottom: 110px;
	}

	.movie_list_1 .movie-list-item {
		width: 48%;
		margin-bottom: 20px;
	}

	.movie_list_1 .movie-list-item-bottom {
		position: relative;
		width: 100%;
		bottom: 42px;
	}

	.movie_list_1 .movie-list-item:nth-child(odd) {
		margin-right: 0;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_1 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
		color: #fff;
	}

	.movie_list_1 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
		height: 35px;
	}

	.movie_list_1 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 5px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 180px;
		padding-left: 8px;
		font-size: 25px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:last-child {
		overflow: hidden;
		white-space: nowrap;
		width: 0px;
		padding-right: 110px;
		font-size: 22px;
	}

	.movie_list_0 .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 350px;
		padding-left: 10px;
		font-size: 25px;
	}

	.hot-recommend-more {
		width: 100%;
		padding-bottom: 20px;
		text-align: center;
		color: #888;
		font-size: 30px;
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #ffffff;
		font-size: 35px;
	}
</style>